import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import alarmRepository from "@/respsitory/AlarmRepository";
import {NoticeBase} from "@/model/alarm/Notice";


const useCreateNotice = () => {
    const queryClient = useQueryClient();

    return useMutation<void, AxiosError, NoticeBase>({
        mutationKey: ["notice", "create"],
        mutationFn: async (body: NoticeBase) => {
            try {
                await alarmRepository.sendNotice(body);
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["noticeHistory"],
                exact: false,
            });
        }
    })
};

export default useCreateNotice;
